import botFlowSchema from '@feedyou/schema/schema/botFlow.json'

export function useSchema() {
  const knowledgeBaseItemSchema = botFlowSchema.properties.knowledgeBases.items

  return knowledgeBaseItemSchema
}
